<template>
  <div class="HeaderMenu" @click="handleAction" v-show="lanmu_list.length != 0">
    <van-icon class="HeaderMenu_icon" name="wap-nav" color="#ffffff" />
    <van-popup
      v-model="show"
      position="right"
      :style="{ width: '61.8%', height: '100%' }"
      get-container="body"
      round
    >
      <div class="nav">
        <van-cell-group title="导航">
          <van-cell title="推荐" size="large" is-link :url="base_url" />
          <van-cell
            v-for="(item, index) in lanmu_list"
            :title="item.tags_name"
            size="large"
            is-link
            :url="`${base_url}#/main/${index + 1}`"
            :key="item.id"
          />
        </van-cell-group>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getInit } from "../sdk/sdk";
export default {
  name: "HeaderMenu",
  data() {
    return {
      show: false,
      lanmu_list: [],
      base_url: "http://www.hnr.cn/?source=mobile",
    };
  },
  async beforeMount() {
    const data = await getInit();
    if (data.state == 1) {
      this.lanmu_list = data.data;
    }
  },
  methods: {
    handleAction() {
      this.show = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.HeaderMenu {
  margin-right: 0.3rem;
  height: 70%;
}
.HeaderMenu_icon {
  width: 100%;
  height: 100%;
  display: block;
  font-size: 1rem;
}

.nav {
  margin-top: 0.4rem;
}
</style>
